<div class="empty-state"
     [class.empty-state--sm]="size() === 'sm'"
     [class.empty-state--lg]="size() === 'lg'">
  <div class="empty-icon" [class.empty-icon--green]="iconVariant() === 'success'">
    <i class="pi" [class]="icon()"></i>
  </div>
  <h3>{{ title() }}</h3>
  @if (message()) {
    <p>{{ message() }}</p>
  }
  <ng-content select="[emptyStateAction]"></ng-content>
</div>
